/**
 * 第三方课程平台 SSO 入口拼接（与 static/js/courseSso.js 保持逻辑一致）
 * 开关由 public/courseSsoConfig.js 中 window.COURSE_SSO_ENABLED 控制（构建产物需包含该文件）。
 *
 * 已在本系统登录时：不再为外链套一层第三方 SSO，直接打开课程 kc_url；
 * 未登录则保持原逻辑（职教云 / 超星 / 智慧树等走对应登录跳转）。
 */

import Cookies from 'js-cookie'
import { hydrateMajorCatalogSessionFromCookies, isMajorCatalogLoginOk } from '@/common/js/majorCatalogSession'

function isCourseSsoEnabled() {
  if (typeof window !== 'undefined' && window.COURSE_SSO_ENABLED === false) {
    return false;
  }
  return true;
}

function safeHostname(kcUrl) {
  if (!kcUrl || typeof kcUrl !== 'string') {
    return '';
  }
  const trimmed = kcUrl.trim();
  if (!trimmed) {
    return '';
  }
  try {
    const u = trimmed.indexOf('//') === -1 ? 'http://' + trimmed : trimmed;
    return new URL(u).hostname.toLowerCase();
  } catch (e) {
    const m = trimmed.match(/(?:https?:)?\/\/([^/?#]+)/i);
    return m ? String(m[1]).toLowerCase() : '';
  }
}

/** 职教云：zjy2.icve.com.cn、*.icve.com.cn、*.icve.cn（与 static/js/courseSso.js 一致） */
function isIcveHost(host) {
  const h = (host || '').toLowerCase();
  if (!h) return false;
  if (h === 'icve.com.cn' || h === 'icve.cn') return true;
  if (h.endsWith('.icve.com.cn') || h.endsWith('.icve.cn')) return true;
  return h.includes('icve.com.cn') || h.includes('icve.cn');
}

function shouldUseDirectCourseUrl() {
  try {
    hydrateMajorCatalogSessionFromCookies()
  } catch (e) {
    /* ignore */
  }
  try {
    if (isMajorCatalogLoginOk()) return true
  } catch (e) {
    /* ignore */
  }
  try {
    const a = Cookies.get('access_token')
    const s = Cookies.get('sys_access_token')
    return !!((a && String(a).trim()) || (s && String(s).trim()))
  } catch (e) {
    return false
  }
}

export function buildCourseSsoUrl(kcUrl, kcSource) {
  if (!kcUrl || typeof kcUrl !== 'string') {
    return kcUrl;
  }
  const trimmed = kcUrl.trim();
  if (!trimmed) {
    return kcUrl;
  }
  if (!isCourseSsoEnabled()) {
    return trimmed;
  }
  if (shouldUseDirectCourseUrl()) {
    return trimmed;
  }
  const source = (kcSource && String(kcSource)) || '';
  const host = safeHostname(trimmed);

  const isChaoxing = () => {
    if (source === '超星泛雅') return true;
    return host.includes('chaoxing.com') || host.includes('chaoxing.cn');
  };
  const isZhihuishu = () => {
    if (source === '智慧树') return true;
    return host.includes('zhihuishu.com');
  };
  const isIcve = () => {
    if (source === '职教云') return true;
    if (isIcveHost(host)) return true;
    return /:\/\/[^/?#]*icve\.(com\.cn|cn)\b/i.test(trimmed);
  };

  const enc = encodeURIComponent(trimmed);
  if (isIcve()) {
    return 'https://sso.icve.com.cn/sso/auth?mode=simple&redirect=' + enc;
  }
  if (isChaoxing()) {
    return 'https://passport2.chaoxing.com/login?refer=' + enc;
  }
  if (isZhihuishu()) {
    return 'https://passport.zhihuishu.com/login?service=' + enc;
  }
  return trimmed;
}

export function openCourseUrl(kcUrl, kcSource) {
  const target = buildCourseSsoUrl(kcUrl, kcSource);
  window.open(target, '_blank');
}
